import { createContext, useContext, useState, useCallback } from "react";
import { toast } from "sonner";

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const [loc, setLoc] = useState(() => {
    const raw = localStorage.getItem("medhone_loc");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const request = useCallback(() => {
    if (!("geolocation" in navigator)) {
      toast.error("Geolocation not supported by this browser");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const l = { lat: pos.coords.latitude, lng: pos.coords.longitude, at: Date.now() };
        setLoc(l);
        localStorage.setItem("medhone_loc", JSON.stringify(l));
        setLoading(false);
        toast.success("Location detected — showing nearby facilities");
      },
      (err) => {
        setLoading(false);
        toast.error(err.message || "Unable to get location");
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  }, []);

  const clear = useCallback(() => {
    setLoc(null);
    localStorage.removeItem("medhone_loc");
    toast.success("Location cleared");
  }, []);

  return (
    <LocationContext.Provider value={{ loc, loading, request, clear }}>
      {children}
    </LocationContext.Provider>
  );
}

export const useLocation = () => useContext(LocationContext);
